/**
 * La pagina del carrito, copiada de Freshly (sections/natnatura-carrito.liquid).
 *
 * Cada −/+, papelera y cupon pide a Shopify el carrito nuevo Y la seccion ya
 * pintada (`sections: [id]`), y sustituye el contenido: ni una cifra se
 * calcula aqui. Mientras llega la respuesta la pagina se atenua con un giro,
 * como en Freshly (`.cart__loading`). Al terminar se emite
 * `shopify:cart:lines-update` para que el globo del icono (cart-icon.js de
 * Horizon) y el mini-carrito se enteren.
 *
 * Sin JS, el formulario sigue siendo un formulario: «Tramitar pedido» lleva
 * `name="checkout"` y Shopify va al pago.
 */
(() => {
  const SEL = '[data-nn-carrito]';
  const raiz = () => document.querySelector(SEL);
  if (!raiz()) return;

  const rutas = (window.Theme && window.Theme.routes) || {};
  const base = (rutas.root_url && rutas.root_url !== '/' ? rutas.root_url.replace(/\/$/, '') : '');
  const URL_CAMBIO = rutas.cart_change_url || base + '/cart/change.js';
  const URL_ACTUALIZA = rutas.cart_update_url || base + '/cart/update.js';

  let ocupado = false;

  const cargando = (si) => {
    const r = raiz();
    if (!r) return;
    ocupado = si;
    r.classList.toggle('nn-carrito--cargando', si);
    const velo = r.querySelector('.nn-carrito__cargando');
    if (velo) velo.hidden = !si;
    r.setAttribute('aria-busy', si ? 'true' : 'false');
  };

  const emitir = (carrito) => {
    const ev = new Event('shopify:cart:lines-update', { bubbles: true });
    ev.action = 'update';
    ev.promise = Promise.resolve({
      cart: { totalQuantity: carrito.item_count },
      detail: { itemCount: carrito.item_count },
    });
    document.dispatchEvent(ev);
  };

  /** Sustituye el contenido de la seccion por el que devuelve Shopify. */
  const repintar = (html) => {
    const r = raiz();
    if (!r || !html) return false;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const nuevo = doc.querySelector(SEL);
    if (!nuevo) return false;
    r.replaceWith(nuevo);
    return true;
  };

  const peticion = async (url, cuerpo) => {
    const r = raiz();
    const id = r ? r.dataset.sectionId : null;
    const respuesta = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(Object.assign({}, cuerpo, id ? { sections: [id] } : {})),
    });
    const datos = await respuesta.json();
    if (!respuesta.ok) throw datos;
    if (datos.sections && id && datos.sections[id]) repintar(datos.sections[id]);
    emitir(datos);
    return datos;
  };

  const cambiar = async (clave, cantidad) => {
    if (ocupado) return;
    cargando(true);
    try {
      await peticion(URL_CAMBIO, { id: clave, quantity: cantidad });
    } catch (e) {
      // Sin seccion (o error): la pagina entera vuelve a pedirse, que es lo
      // que hace un formulario sin JS.
      window.location.reload();
      return;
    }
    cargando(false);
  };

  const codigosActuales = () => {
    const r = raiz();
    return r ? Array.from(r.querySelectorAll('[data-nn-cupon-quitar]')).map((b) => b.dataset.nnCuponQuitar) : [];
  };

  const aplicarCupon = async (codigo) => {
    if (ocupado || !codigo) return;
    const r = raiz();
    const error = r && r.querySelector('[data-nn-cupon-error]');
    if (error) error.hidden = true;
    cargando(true);
    const codigos = codigosActuales().filter((c) => c.toUpperCase() !== codigo.toUpperCase());
    codigos.push(codigo);
    try {
      const datos = await peticion(URL_ACTUALIZA, { discount: codigos.join(',') });
      const puesto = (datos.discount_codes || []).find(
        (d) => d.code.toUpperCase() === codigo.toUpperCase() && d.applicable
      );
      if (!puesto) {
        // El codigo no vale: se quita para que no se quede pegado al carrito
        // y se enseña el aviso en el tile del cupon.
        const limpios = codigos.filter((c) => c.toUpperCase() !== codigo.toUpperCase());
        await peticion(URL_ACTUALIZA, { discount: limpios.join(',') });
        const r2 = raiz();
        const error2 = r2 && r2.querySelector('[data-nn-cupon-error]');
        if (error2) error2.hidden = false;
        const campo = r2 && r2.querySelector('[data-nn-cupon-form] input[name="discount"]');
        if (campo) {
          campo.value = codigo;
          campo.focus();
        }
      }
    } catch (e) {
      const r3 = raiz();
      const error3 = r3 && r3.querySelector('[data-nn-cupon-error]');
      if (error3) error3.hidden = false;
    }
    cargando(false);
  };

  const quitarCupon = async (codigo) => {
    if (ocupado) return;
    cargando(true);
    const codigos = codigosActuales().filter((c) => c.toUpperCase() !== codigo.toUpperCase());
    try {
      await peticion(URL_ACTUALIZA, { discount: codigos.join(',') });
    } catch (e) {
      window.location.reload();
      return;
    }
    cargando(false);
  };

  /** Abre el pop-up del boletin (natnatura-captacion) desde «Recoger cupón». */
  const recogerCupon = () => {
    document.dispatchEvent(new CustomEvent('nn:captacion:abrir', { bubbles: true }));
  };

  // Todo por delegacion desde `document`: la seccion se sustituye entera en
  // cada actualizacion (y el hot reload de `theme dev` tambien la sustituye),
  // asi que nada se cuelga del nodo que se va a tirar.
  document.addEventListener('click', (e) => {
    if (!e.target.closest(SEL)) return;
    const paso = e.target.closest('[data-nn-paso]');
    const quitar = e.target.closest('[data-nn-quitar]');
    const quitarCupon_ = e.target.closest('[data-nn-cupon-quitar]');
    const recoger = e.target.closest('[data-nn-recoger-cupon]');
    if (recoger) {
      e.preventDefault();
      recogerCupon();
      return;
    }
    if (quitarCupon_) {
      e.preventDefault();
      quitarCupon(quitarCupon_.dataset.nnCuponQuitar);
      return;
    }
    const linea = e.target.closest('[data-nn-linea]');
    if (!linea) return;
    const actual = parseInt(linea.dataset.nnCantidad, 10) || 0;
    if (paso) {
      e.preventDefault();
      cambiar(linea.dataset.nnLinea, Math.max(0, actual + parseInt(paso.dataset.nnPaso, 10)));
    } else if (quitar) {
      e.preventDefault();
      cambiar(linea.dataset.nnLinea, 0);
    }
  });

  document.addEventListener('submit', (e) => {
    const cupon = e.target.closest && e.target.closest('[data-nn-cupon-form]');
    if (!cupon || !cupon.closest(SEL)) return;
    e.preventDefault();
    const campo = cupon.querySelector('input[name="discount"]');
    const codigo = campo ? campo.value.trim() : '';
    if (!codigo) {
      if (campo) campo.focus();
      return;
    }
    aplicarCupon(codigo);
  });

  // Si algo mas cambia el carrito (el mini-carrito, el boton de una
  // tarjeta de «Otros clientes…»), la pagina se vuelve a pedir pintada.
  // OJO: sin `Accept: application/json`. Con esa cabecera, `/cart?sections=`
  // devuelve el JSON del carrito (como /cart.js) en vez de las secciones, y
  // la pagina no se repintaba (06/10/2026).
  document.addEventListener('shopify:cart:lines-update', (evento) => {
    if (evento.action !== 'add' || !evento.promise) return;
    evento.promise
      .then(async () => {
        const r = raiz();
        const id = r ? r.dataset.sectionId : null;
        if (!id) return;
        const secciones = await fetch(window.location.pathname + '?sections=' + encodeURIComponent(id)).then((x) =>
          x.json()
        );
        if (secciones && secciones[id]) repintar(secciones[id]);
      })
      .catch(() => {});
  });

})();
